import { render, staticRenderFns } from "./ResultadoFinal.vue?vue&type=template&id=fd4f3e7c&scoped=true"
import script from "./ResultadoFinal.vue?vue&type=script&lang=js"
export * from "./ResultadoFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4f3e7c",
  null
  
)

export default component.exports